<template>
  <div id="app">
    <template v-if="isLessIE11">
      <div class="lowv">
        <div class="download_tips">
          <div class="tip_content">
            <h2>请升级您的浏览器</h2>
            <p>尊敬的用户，您正在使用的浏览器版本过低 ，无法正常访问我们的网站，建议您升级或选用其它浏览器</p>
            <p>我们列出了一些最受欢迎的浏览器供您选择，点击图标将转到相应下载页：</p>
            <div class="logos">
              <a class="recommend" href="https://www.google.cn/intl/zh-CN/chrome/">
                <img src="@/assets/imgs/browsers/img_chrome.png">
                <p>Chrome</p>
              </a>
              <a href="https://www.firefox.com.cn/">
                <img src="@/assets/imgs/browsers/img_firefox.png">
                <p>Firefox</p>
              </a>
              <a href="https://browser.360.cn/">
                <img src="@/assets/imgs/browsers/img_360.png">
                <p>360浏览器</p>
              </a>
              <a href="https://ie.sogou.com/">
                <img src="@/assets/imgs/browsers/img_sogou.png">
                <p>搜狗</p>
              </a>
            </div>
          </div>
        </div>
      </div>
    </template>

    <template v-else>
      <a-locale-provider :locale="zh_CN">
      <router-view />
      </a-locale-provider>
    </template>
  </div>
</template>

<script>
import zh_CN from 'ant-design-vue/lib/locale-provider/zh_CN';
import aFooter from './components/public/Footer';

export default {
  name: 'App',
  components: {
    aFooter,
  },
  data() {
    return {
      zh_CN,
      isLessIE11: false,
    };
  },
  created () {
    const userAgent = navigator.userAgent;
    //判断是否IE<11浏览器，'MSIE'=25就是低于IE11，
    const isLessIE11 = userAgent.indexOf('compatible') > -1 && userAgent.indexOf('MSIE') > -1;
    if (isLessIE11) {
      this.isLessIE11 = true;
    }
  }
};
</script>

<style lang="less">
html,
html body {
  height: 100%;
  margin: 0;
  padding: 0;
}
body {
  background-size: 100% 100%;
  font-family: yahei,Arial, Helvetica, sans-serif
}
#app { 
  width: 100%;
  min-width: 1230px;
  min-height: 100vh; 
  text-align: center;
  color: #2c3e50;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .lowv {
    height: 100%;
    .download_tips {
      max-width: 1180px;
      padding-top: 270px;
      margin: 0 auto;
      .tip_content {
        height: 360px;
        box-sizing: border-box;
        text-align: center;
        padding: 50px 0;
        background-color: #fff;
        box-shadow:0px 10px 20px 0px rgba(107,121,142,0.05);
        h2 {
          font-size: 20px;
          color: #0A1633;
          font-weight: 700;
          margin: 0;
        }
        p {
          font-size: 14px;
          color: #0A1633;
          margin: 12px 0 0;
        }
        .logos {
          max-width: 660px;
          margin: 45px auto 0;
          a {
            display: inline-block;
            width: 23%;
            box-sizing: border-box;
            text-decoration: none;
            img {
              width: 68px;
            }
            p {
              margin-top: 20px;
            }
          }
          .recommend {
            position: relative;
            &:after {
              content: "推荐";
              position: absolute;
              right: 15px;
              top: 0;
              font-size: 10px;
              text-align: center;
              width: 32px;
              height: 14px;
              border-radius: 8px;
              background-color: #FF0000;
              color: #fff;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue